'use client'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark, faBell, faArrowRight } from '@fortawesome/pro-solid-svg-icons'
import {
  Button,
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from '@teqplay/ui'
import { useTranslations } from 'next-intl'
import Image from 'next/image'
import Link from 'next/link'

import { useAnalytics } from '@/app/lib/analytics'

import './ModalPortReporter.scss'

export type TPropsModalPortReporter = {
  isOpen: boolean
  onClose: () => void
}

const ModalPortReporter = ({ isOpen, onClose }: TPropsModalPortReporter) => {
  const t = useTranslations('VesselAlertCTA.prpCTA.modal')
  const { trackTeqplayRedirectCTA } = useAnalytics()

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent
        aria-describedby="port-reporter-modal-description"
        className="dialog-port-reporter"
      >
        <DialogClose asChild>
          <Button variant="neutral-tertiary" className="dialog-close-btn">
            <FontAwesomeIcon icon={faXmark} />
          </Button>
        </DialogClose>

        <DialogHeader className="dialog-port-reporter-header">
          <DialogTitle asChild>
            <h2>
              <FontAwesomeIcon icon={faBell} />
              {t('title')}
            </h2>
          </DialogTitle>
        </DialogHeader>

        <div id="port-reporter-modal-description" className="dialog-port-reporter-content">
          <img
            src="https://teqplay.com/wp-content/uploads/2023/09/port-reporter.png"
            alt={t('title')}
            width={600}
            height={400}
            className="dialog-port-reporter-image"
          />
          <p className="dialog-port-reporter-message">{t('message')}</p>
        </div>

        <DialogFooter className="dialog-port-reporter-footer">
          <Link
            href="https://teqplay.com/smarter-operations/port-reporter/"
            className="button brand-primary"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() =>
              trackTeqplayRedirectCTA({
                source: 'port_reporter_modal',
                url: 'https://teqplay.com/smarter-operations/port-reporter/'
              })
            }
          >
            {t('button')}
            <FontAwesomeIcon icon={faArrowRight} />
          </Link>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default ModalPortReporter
